import { createPathSelectBuildingInBuildMenu } from "../../../path/createPathSelectBuildingInBuildMenu";
export var pathSelectBuildingInBuildMenuHaveBuilding = function (action, state$, deps) { return createPathSelectBuildingInBuildMenu(function () { return action.taskType.buildingId; })(action, state$, deps); };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/paths/pathSelectBuildingInBuildMenuHaveBuilding.ts
// module id = 2379
// module chunks = 3